import styled from 'styled-components/macro'

export const LinkText = styled.p`
  cursor: pointer;
`
